import { PropsWithChildren, useMemo } from 'react';
import { styled, Box, Typography, Tooltip } from '@mui/material';

const AccessUnitAlert = styled(Box)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.warning.light}`,
  paddingLeft: theme.spacing(1),
}));

export default function AlertStatusMessage({
  message,
  maxChars = 30,
  children,
}: PropsWithChildren<{ message?: string; maxChars?: number }>) {
  const messageElem = useMemo(() => {
    if (!message) return undefined;

    if (message.length <= maxChars) {
      return (
        <Typography variant="tooltip" color="warning.light" noWrap component="div">
          {message}
        </Typography>
      );
    }

    return (
      <Tooltip
        arrow
        title={
          <Typography variant="tooltip" color="warning.light">
            {message}
          </Typography>
        }
        placement="left"
      >
        <Typography variant="tooltip" color="warning.light" noWrap component="div">
          {message.substring(0, maxChars) + '...'}
        </Typography>
      </Tooltip>
    );
  }, [maxChars, message]);

  if (!message) return <>{children}</>;

  return (
    <AccessUnitAlert>
      {children}
      {messageElem}
    </AccessUnitAlert>
  );
}
